<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('school.payment.setup.feeSetup.copyFee') }}
        </h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="col-form-label">
                {{
                  $t(
                    'school.payment.setup.feeSetup.academicYearInCurrentBranch'
                  )
                }}
                <span class="validate">*</span>
              </label>
              <a-select
                v-model="model.login_ac_year_id"
                class="ts-w-full"
                :options="academicYearByBranch(defaultBranchId)"
                showSearch
                :placeholder="$t('school.payment.setup.feeSetup.academicYear')"
              >
              </a-select>
              <div
                v-if="errors.has(`login_ac_year_id.ac_year_id`)"
                class="ts-text-red-500"
              >
                {{ errors.first(`login_ac_year_id.ac_year_id`) }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="col-form-label">
                {{ $t('school.payment.setup.feeSetup.fromBranch') }}
                <span class="validate">*</span>
              </label>
              <select
                v-model="model.copy_from_branch_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('copy_from_branch_id') }"
                @change="onCopyFromBranchChange"
              >
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(branch, index) in branchList"
                  :key="index"
                  :value="branch.branch_id"
                  >{{ branch.branch_name_en }}</option
                >
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('copy_from_branch_id')"
              >
                {{ errors.first('copy_from_branch_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="col-form-label">
                {{ $t('school.payment.setup.feeSetup.academicYearFromBranch') }}
                <span class="validate">*</span>
              </label>
              <a-select
                v-model="model.copy_from_ac_year_id"
                class="ts-w-full"
                :options="academicYearByBranch(model.copy_from_branch_id)"
                :placeholder="$t('school.payment.setup.feeSetup.academicYear')"
              >
              </a-select>
              <div
                v-if="errors.has(`copy_from_ac_year_id.ac_year_id`)"
                class="ts-text-red-500"
              >
                {{ errors.first(`copy_from_ac_year_id.ac_year_id`) }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="col-form-label">
                {{ $t('school.payment.setup.feeSetup.mainProgram') }}
                <i
                  class="fas fa-question-circle"
                  v-tooltip="
                    $t(
                      'school.payment.setup.feeSetup.chooseMainProgramToFilterSubProgram'
                    )
                  "
                ></i>
              </label>
              <select
                class="form-control"
                v-model="model.acp_id"
                @change="fetchSubProgram"
              >
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(main, index) in mainPrograms"
                  :key="index"
                  :value="main.acp_id"
                  >{{ main.acp_name_foreign }}</option
                >
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <label class="col-form-label required">
                {{ $t('school.payment.setup.fee_type.fee_type') }}
              </label>
              <select class="form-control" v-model="model.fee_type_id">
                <option value>{{ $t('select') }}</option>
                <option
                  v-for="(feeType, index) in feeTypes"
                  :key="index"
                  :value="feeType.value"
                >
                  {{ feeType.text }}
                </option>
              </select>
              <div class="validate" v-if="errors.has('fee_type_id')">
                {{ errors.first('fee_type_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group">
              <form>
                <fieldset>
                  <legend>
                    {{ $t('school.payment.setup.feeSetup.subProgram') }}
                  </legend>
                  <div>
                    <div
                      class="row col-md-12 form-group"
                      v-if="subPrograms.length > 0"
                    >
                      <ts-checkbox @change="checkAllSub" :checked="checked">
                        {{ $t('selectAll') }}
                      </ts-checkbox>
                    </div>
                    <div id="sub-list-container">
                      <div
                        class="row col-md-12 form-group"
                        v-for="(sub, index) in subPrograms"
                        :key="index"
                      >
                        <ts-checkbox
                          v-model="model.acps_id_list"
                          :value="sub.acps_id"
                          >{{ sub.acps_name_foreign }}</ts-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
              <div class="validate" v-if="errors.has('acps_id_list')">
                {{ errors.first('acps_id_list') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button @click="$emit('close')">{{ $t('cancel') }}</ts-button>
              <ts-button
                @click="copy"
                class="ml-2"
                color="primary"
                :waiting="waiting"
                >{{ $t('copy') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'copyFee',
  data() {
    return {
      model: {
        copy_from_branch_id: '',
        acps_id_list: [],
        acp_id: '',
        fee_type_id: '',
        login_ac_year_id: undefined,
        copy_from_ac_year_id: undefined
      },
      academicYears: [],
      loading: false,
      allCheck: false,
      subPrograms: [],
      waiting: false,
      errors: new Errors()
    }
  },
  mounted() {
    this.$store.commit('feeSetup/SET_BRANCH', [])
    this.fetchResource()
  },
  computed: {
    ...mapState('feeSetup', ['branchList', 'mainPrograms', 'feeTypes']),
    defaultBranchId() {
      return this.$store.state.authUser.default_branch_id
    },
    academicYearByBranch: vm => branchId => {
      return vm.academicYears
        .filter(ac => ac.branch_id === branchId)
        .map(el => ({
          value: el.ac_year_id,
          label: `${el.ac_year} - ${el.ac_status_description}`
        }))
    },
    checked() {
      return this.subPrograms.length == this.model.acps_id_list.length
    }
  },
  methods: {
    ...mapActions('feeSetup', ['getBranch', 'getMainProgram', 'fetch']),
    async fetchResource() {
      this.loading = true
      await Promise.all([
        this.getBranch(),
        this.getMainProgram(),
        this.fetchAcademicYear()
      ])
      this.loading = false
    },
    async fetchAcademicYear(branchId = undefined) {
      let response = await this.$store.dispatch('feeSetup/getAcademicYear', {
        branch_id: branchId ? branchId : this.defaultBranchId
      })
      const newYears = response.academic_years

      // Create a map by ID to ensure uniqueness
      const combined = [...this.academicYears, ...newYears]
      const uniqueMap = new Map(combined.map(item => [item.ac_year_id, item]))
      this.academicYears = Array.from(uniqueMap.values())
      return response
    },
    fetchSubProgram() {
      if (this.model.acp_id) {
        this.loading = true
        this.$store
          .dispatch('feeSetup/getSubProgram', this.model.acp_id)
          .then(response => {
            this.subPrograms = response.data
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.subPrograms = []
      }
    },
    checkAllSub(value) {
      if (value) {
        this.model.acps_id_list = []
        this.subPrograms.map(el => {
          this.model.acps_id_list.push(el.acps_id)
        })
      } else {
        this.model.acps_id_list = []
      }
    },
    copy() {
      this.waiting = true
      this.$store
        .dispatch('feeSetup/copyFee', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetch()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onCopyFromBranchChange() {
      this.loading = true
      this.model.copy_from_ac_year_id = undefined
      await this.fetchAcademicYear(this.model.copy_from_branch_id).finally(
        () => (this.loading = false)
      )
    }
  }
}
</script>
<style scoped>
#sub-list-container {
  max-height: 30vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}</style
>>
